<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1300px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px; padding-left:10px;">
            <el-button type="text">
              查询条件
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.nickname"
              placeholder="请输入昵称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.storeName"
              placeholder="请输入门店名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table2
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @deal="dealFun(arguments)"
        />
      </div>

      <!-- 异常处理 -->
      <deal-exception-dialog
        :event-type="'add'"
        :data-id="id"
        :dialog-title="dialogAddTitle"
        :dialog-visible.sync="dialogAddVisible"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin2 from '@/mixin/dialogTableCustomMixin2'
// 异常处理
import dealExceptionDialog from './dealExceptionDialog'
// 方案服务项目API
import { loadSurveyQuestionnaireDetailExceptionListDataApi } from '@/api/v2/surveyQuestionnaireDetailException';

export default {
  name: 'TodoDealDetailExceptionList',
  components: { CustomTable2, dealExceptionDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin2],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'questionnaire_detail_exception_todo_list_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'deal',
            label: '处理问卷明细异常',
            method: 'deal'
          },
          // {
          //   prop: 'notNeed',
          //   label: '取消定样',
          //   method: 'notNeed'
          // }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          nickname: '',
          storeName: '',
          certificateNo: '',
          processResult: 1
        }
      },
      isPaging: true,
      dialogAddTitle: '',
      dialogAddVisible: false,
      id: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.tableList.initTableColumn = [
          { prop: 'rowNumber', label: '序号', width: 80 },
          { prop: 'provinceName', label: '省区', filterColumn: 'tsq.province_name', width: 100 },
            { prop: 'questionnaireCode', label: '问卷编号', filterColumn: 'tsq.code', width: 110 },
            { prop: 'questionnaireName', label: '问卷名称', filterColumn: 'tsq.name', width: 200 },
            { prop: 'activityDate', label: '活动日期', filterColumn: 'tsq.activity_date', width: 110 },
            { prop: 'nickname', label: '昵称', filterColumn: 'tsqd.nickname', width: 150 },
            { prop: 'market', label: '市场', filterColumn: 'tsqd.market', width: 150 },
            { prop: 'storeName', label: '门店名称', filterColumn: 'tsqd.store_name', width: 200 },
            { prop: 'certificateNo', label: '专卖证号', filterColumn: 'tsqd.certificate_no', width: 120 },
            { prop: 'bxPhone', label: '本香门店码绑定电话', filterColumn: 'tsqd.bx_phone', width: 165 },
            { prop: 'uid', label: '问卷用户ID', filterColumn: "tsqd.uid", width: 200 },
            { prop: 'appUserId', label: '小程序用户编号', filterColumn: "tsqd.app_user_id", width: 150 },
            { prop: 'appStoreName', label: '小程序门店名称', filterColumn: "IFNULL(tau.store_name, '')", width: 150 },
            { prop: 'appCertificateNo', label: '小程序专卖证号', filterColumn: "IFNULL(tau.certificate_no, '')", width: 150 },
            { prop: 'appPhone', label: '小程序手机号', filterColumn: "IFNULL(tau.phone, '')", width: 130 },
            { prop: 'exceptionTypeValue', label: '异常类型', filterColumn: "(case tsqde.exception_type when 2 then '录入专卖证号重复' when 3 then '问卷用户重复录入' when 4 then '专卖证号错误' when 5 then '未注册睿零售' when 6 then '腾讯问卷用户ID不一致' when 7 then '录入专卖证号与关联的睿零售不一致' when 8 then '微信用户未绑定睿零售' when 9 then '其他调研专卖证号与匹配专卖证号存在重复' when 10 then '数据关联睿零售重复' else '' end)", width: 150 },
        ]
        _this.tableList.tableColumns = _this.tableList.initTableColumn
        _this.searchData(_this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadSurveyQuestionnaireDetailExceptionListDataApi(_this.tableList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(_this.tableList, data.list || []);
        _this.tableList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      let _this = this;
      _this.$emit('reloadData');
      _this.loadTableData(_this.tableList);
    },
    // 创建定样单
    dealFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogAddTitle = '处理问卷明细异常信息'
      _this.dialogAddVisible = !_this.dialogAddVisible
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
